import { ReactComponent as NoResultLogo } from "../../../resources/icons/Group 2611 (1).svg";

export function FormsListEmpty() {
    return (
        <div className="flex flex-col items-center bg-system-white p-48 rounded-2xl flex-1">
            <NoResultLogo className="mb-16" />
            <p className="text-n font-normal text-extra-placeholder-text">
                Ingen resultater blev fundet.
            </p>
        </div>
    );
}
